import moment from 'moment';

const format = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});
const dateReducer = (o, curr) => ({
  ...o,
  [curr.type]: curr.value,
});
export default {
  data() {
    return {
    };
  },
  methods: {
    buildDateString(daysToGoBack) {
      const d = new Date();
      d.setDate(d.getDate() - daysToGoBack);
      const dd = `0${d.getDate()}`.slice(-2);
      const mm = `0${d.getMonth() + 1}`.slice(-2);
      const yyyy = d.getFullYear();
      const date = `${yyyy}-${mm}-${dd}`;
      return date;
    },
    displayDOBFormat(value) {
      const [year, month, day] = value.split('-');
      const date = [month, day, year].join('/');
      return date;
    },
    isValidDateFormat(date, fmt) {
      return moment(date, fmt, true).isValid();
    },
    toDateInputValue(value) {
      // Normalize a date or datetime value to a `YYYY-MM-DD` string suitable for
      // a native <input type="date">. Any time component is dropped for display
      // only; the source value is left untouched. Returns null for empty/invalid.
      // parseZone keeps the offset written in the value (e.g. "+05:30") instead of
      // converting to the browser's local time, so the date is never shifted across
      // midnight by the viewer's timezone.
      if (!value) return null;
      const m = moment.parseZone(value);
      return m.isValid() ? m.format('YYYY-MM-DD') : null;
    },
    isValidDOB(date, formatDate) {
      if (date) {
        const m = moment(date, formatDate, true);
        if (!m.isValid()) return false;

        const dateOfBirth = m.format(formatDate);
        const currentDate = moment().format(formatDate);
        const birthYear = dateOfBirth.substring(0, 4);
        const valid = dateOfBirth <= currentDate && birthYear > 1899;
        return valid;
      }
      return null;
    },

    isValidDOBWithfutureBirthYearsAllowed(date, formatDate) {
      if (date) {
        const m = moment(date, formatDate, true);
        if (!m.isValid()) return false;

        const dateOfBirth = m.format(formatDate);
        const birthYear = dateOfBirth.substring(0, 4);
        return birthYear > 1899;
      }
      return null;
    },

    getCorrectDateFromYYYYMMDDString(dateString) {
      if (dateString !== undefined) {
        const year = dateString.substring(0, 4);
        const month = dateString.substring(5, 7);
        const day = dateString.substring(8);
        const date = new Date(year, month - 1, day);
        return date;
      }
      return null;
    },
    getCorrectDateFromMMDDYYYYString(dateString) {
      if (dateString !== undefined) {
        const month = dateString.substring(0, 2);
        const day = dateString.substring(3, 5);
        const year = dateString.substring(6);
        const date = new Date(year, month - 1, day);
        return date;
      }
      return null;
    },
    padDateWithZeroes(d) {
      let s = '';
      const parts = d.split('/');
      if (parts) {
        parts.forEach((p) => {
          s += this.zeroPad(p, 2);
          s += '/';
        });
        s = s.slice(0, -1);
      } else {
        s += this.zeroPad(d, 2);
      }
      return s;
    },
    zeroPad(num, places) {
      const zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join('0') + num;
    },
    createExtractFileNameWithDateTime(matchType, submissionType, transOrBatchNumber, extractDate, millStrSub, fileType) {
      const dateObj = this.createDateObject(extractDate);

      // extract parts as local variables
      const {
        year,
        month,
        day,
        hour,
        minute,
        second,
      } = dateObj;


      let extractName = '';
      let submissionTypeStr = submissionType.toUpperCase();
      const matchTypeStr = matchType.toUpperCase();

      if (fileType === 'SEARCH') {
        extractName = `DM_${matchTypeStr}_${fileType}_${year}${month}${day}_${hour}${minute}${second}_MCH`;
      } else {
        if (submissionType.includes('Person ID')) {
          if (submissionType.includes('State')) {
            submissionTypeStr = 'PERSONID_STATE';
          } else {
            submissionTypeStr = 'PERSONID';
          }
        }
        extractName = `DM_${matchTypeStr}_${submissionTypeStr}_${transOrBatchNumber}_${year}${month}${day}_${hour}${minute}${second}_${fileType}`;
      }

      return extractName;
    },
    createDateObject(extractDate) {
      // split the date into an array of parts
      const parts = format.formatToParts(extractDate);

      // reduce the array into an object
      return parts.reduce(dateReducer, {});
    },
  },
};
